
import { Workout } from "../interfaces/workout.interface";

export class WorkoutClass implements Workout {
  id: number = null;
  audio?: string = ''
  video?: string = ''
  done: boolean = false
  order: number = null
  workout: string = ''
  description: string = ''
  repetitions: number = null
  duration: string = ''
  rest_time_in_sec: number = null
  media: Array<any> = []
}
